import React from 'react';
import type { Testimonial } from '../data/salesContent';
type TestimonialRailProps = {
  items: Testimonial[];
  hint: string;
};
export function TestimonialRail({
  items,
  hint
}: TestimonialRailProps) {
  return <div data-id="element-155" data-mp="34iuh1vj5r3ga">
      <p className="mb-4 text-center text-[11px] font-medium uppercase tracking-[0.18em] text-muted" data-id="element-156" data-mp="34j469gwdp6kx">
        {hint}
      </p>
      <ul className="no-scrollbar -mx-5 flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-2 sm:mx-0 sm:px-0" aria-label="Customer testimonials" data-id="element-157" data-mp="39j00wpj6rlnt">
        {items.map(t => <li key={t.initials + t.name} className="flex w-[18.5rem] shrink-0 snap-start flex-col rounded-2xl border border-white/10 bg-ink-700 p-6 sm:w-[21rem]" data-id="element-158" data-mp="54s6mmna40tm">
            <div className="flex items-center gap-3" data-id="element-159" data-mp="3sdnh2j8nl5sn">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-lilac-500 text-xs font-bold text-white" data-id="element-160" data-mp="jywxou28mszy">
                {t.initials}
              </span>
              <span className="text-sm tracking-tight text-gold" aria-label="5 out of 5 stars" data-id="element-161" data-mp="2fpkcj3rqrbav">
                ★★★★★
              </span>
            </div>
            <blockquote className="mt-4 text-[15px] leading-relaxed text-white" data-id="element-162" data-mp="2bmxdahsqqo3n">
              “{t.quote}”
            </blockquote>
            <footer className="mt-auto pt-5 text-sm font-semibold text-lilac-300" data-id="element-163" data-mp="2kowv3cbkxw7n">
              — {t.name} · <span className="font-normal text-muted" data-id="element-164" data-mp="2zdtcw13funlg">{t.location}</span>
            </footer>
          </li>)}
      </ul>
    </div>;
}